const INIT_STATE = {};
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...state,
        token: action.payload.token,
        expiration: action.payload.expiration,
        refreshTokenExpiration: action.payload.refreshTokenExpiration,
        refreshToken: action.payload.refreshToken,
      };
    case "LOGIN_ERROR":
      return INIT_STATE;
    default:
      return state;
  }
};
